"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userCannotAccessRoute = exports.userCanAccessRoute = void 0;
// To be used inside a `filter` to filter registered routes for the given user, to ensure the current user is
// allowed to access the route.
var userCanAccessRoute = function (userIsAuthenticated, userPermissions) { return function (route) {
    if (!route.authenticated) {
        return true;
    }
    if (route.authenticated && !userIsAuthenticated) {
        return false;
    }
    var routePermissions = route.permissions;
    if (routePermissions === undefined) {
        // If there are no route permissions supplied, then it's safe to assume that you can access the route without needing any
        return true;
    }
    // The user permission list must contain every required route permission
    // TODO consider logical OR case
    return (userPermissions !== undefined &&
        routePermissions.every(function (routePermission) { return userPermissions.includes(routePermission); }));
}; };
exports.userCanAccessRoute = userCanAccessRoute;
// Inverse of the above - extracted here for simplicity in the component
var userCannotAccessRoute = function (userIsAuthenticated, userPermissions) { return function (route) { return !exports.userCanAccessRoute(userIsAuthenticated, userPermissions)(route); }; };
exports.userCannotAccessRoute = userCannotAccessRoute;
//# sourceMappingURL=AuthControlledNavigation.js.map